import cn from 'classnames';
import { CSSProperties, FC, useEffect, useState } from 'react';
import { isDesktop } from 'react-device-detect';
import { useSelector } from 'react-redux';
import { Typography } from 'src/components/common/Typography';
import { useI18n } from 'src/hooks/use-i18n-translation';
import { useBannerActions } from 'src/hooks/useBannerActions';
import { useGameAction } from 'src/hooks/useGameAction';
import { getNewsletter } from 'src/services/cmsApi';
import { CmsNewsletter, CmsWidget } from 'src/types/cms/cmsWidgetTypes';
import { RootState } from 'src/types/store-types';
import './styles.scss';

type Props = {
  settings: {
    priority: number;
    styles: Styles;
    needLogin: boolean;
    classes: 'dark' | 'primary' | 'light';
  };
};
const NewsLetter: FC<Props> = ({ settings }) => {
  const { styles, classes } = settings;
  const { locale } = useI18n();
  const [newsLetter, setNewsletter] = useState<CmsWidget<CmsNewsletter> | null>(null);
  const { selectedCategory } = useSelector((state: RootState) => state.app);
  const { tags } = useSelector((state: RootState) => state.games);
  const [tagList, setTagList] = useState<any[]>([]);
  const { categoriesData } = useSelector((state: RootState) => state.configs);
  const { providerAction, loginAction, registrAction, promotionAction, categoryAction, externalUrlAction } =
    useBannerActions();

  const { handleActionGame } = useGameAction();

  const ctaAction = (): void => {
    const cta = newsLetter?.content?.action;

    if (!cta) return;

    switch (cta?.variant) {
      case 'goToRegister':
        registrAction();
        break;
      case 'goToLogin':
        loginAction();
        break;
      case 'goToPromotion':
        promotionAction(cta?.param);
        break;
      case 'goToProvider':
        providerAction({ provider: cta?.param, tags: tags, tagList: tagList });
        break;
      case 'goToExternalUrl':
        externalUrlAction(cta?.param);
        break;
      case 'goToGame':
        handleActionGame(cta?.param as number);
        break;
      case 'goToCategory':
        categoryAction(cta?.param);
        break;
      case 'goToRace':
      case 'noAction':
        break;
      default:
        return;
    }
  };

  useEffect(() => {
    getNewsletter(locale).then((res) => {
      if (res.success) {
        setNewsletter(res.result?.[0] as CmsWidget<CmsNewsletter>);
      }
    });
  }, [locale]);

  useEffect(() => {
    categoriesData &&
      setTagList(categoriesData[selectedCategory]?.tags?.filter((f) => f.tagName === 'allGames')?.[0].tagGames || []);
  }, [categoriesData]);

  return newsLetter?.content?.newsletterText ? (
    <div className={cn('newsLetter_container', classes)} style={styles}>
      <div
        className="text-wrapper"
        style={{ '--start-position': isDesktop ? '100%' : '80%' } as CSSProperties}
        onClick={ctaAction}
      >
        <Typography className="text" variant={'body4'} component={'p'}>
          {newsLetter.content.newsletterText || 'NEWS_LETTER'}
        </Typography>
      </div>
    </div>
  ) : null;
};
export default NewsLetter;
